import { useState, useCallback } from 'react'
import getShareableLinks from '../lib/getShareableLinks'
import getShareableLinksDeprecated, {
  ShareableLinkDataDeprecated,
} from '../lib/getShareableLinksDeprecated'
import { Links } from '../lib/types'
import { ShareContextData } from '../provider/ShareContext'

type ShareLinks = {
  links: Links | null
  loading: boolean
  error: boolean
  onFetchLinks: (args?: {
    useDeprecated?: boolean
    isLessonShare?: boolean
  }) => void
}

const useFetchShareLinks = (shareData: ShareContextData): ShareLinks => {
  const [links, setLinks] = useState<Links | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)

  const onFetchLinks = useCallback(
    async ({ useDeprecated = false, isLessonShare = false } = {}) => {
      let response

      try {
        setLoading(true)

        if (useDeprecated) {
          // In NextJS, getShareableLinks endpoint is not working so this is a
          // workaround for v1.
          response = getShareableLinksDeprecated(
            shareData as ShareableLinkDataDeprecated,
            isLessonShare,
          )
        } else {
          response = await getShareableLinks(shareData, isLessonShare)
        }

        setLinks(response)
      } catch {
        setError(true)
      } finally {
        setLoading(false)
      }
    },
    [shareData],
  )

  return { links, loading, error, onFetchLinks }
}

export default useFetchShareLinks
